/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

export const isValidParamLength = (param = '') => {
  return param.length > 0 && param.length <= 250
}
